<!-- 学段资源建设分布 -->
<template>
    <div class="state-resource-chart">
        <div class="state-resource-chart-title">
            <div class="name">学段资源建设分布</div>
            <!-- <div class="detail">详情<i class="el-icon-arrow-right"></i></div> -->
        </div>
        <div class="chart" id="stateResourceChartId"></div>
    </div>
</template>
<script>
import { getPlatformSubjectResourceStatAPI } from "@/service/api.js"
export default {
    name: 'stage-resource-distribution-chart',
    components: {
    },
    props: {
        //区域id
        regionId: {
            type: String,
            default: ''
        },
        //省id
        provinceId: {
            type: String,
            default: ''
        },
        //市id
        cityId: {
            type: String,
            default: ''
        },
        //区id
        districtId: {
            type: String,
            default: ''
        },
        //乡镇地址
        address: {
            type: String,
            default: ''
        },
        //开始时间
        startTime: {
            type: String,
            default: ""
        },
        //结束时间
        endTime: {
            type: String,
            default: ""
        },
    },
    data() {
        return {
            phase: { '小学': "1", '初中': '2', '高中': '3' },
            resourcearr: []
        }
    },
    computed: {
        intervalTime() {
            return [this.startTime, this.endTime];
        }
    },
    watch: {
        intervalTime() {
            this.getStateresource();
        },
        schoolId() {
            this.getStateresource();
        },
        address() {
            this.getStateresource();
        }
    },
    methods: {
        /**
          * @name 初始化图表
          */
        initEchart() {
            let _this = this;
            let namelist = []
            namelist = this.resourcearr.map((item) => {
                return {
                    ...item,
                    name: `${item.title}   ${item.value}`
                }
            })
            let dataSource = _this.$echarts.init(
                document.getElementById('stateResourceChartId')
            );
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: (data) => {
                        return data.data.title + "：" + data.value;
                    },
                },
                legend: {
                    orient: "vertical",
                    left: "60%",
                    top: "middle",
                    icon: "circle",
                    textStyle: {
                        color: "#FFF",
                        rich: {
                            a: {
                                align: "left",
                                width: 100,
                            },
                            b: {
                                align: "left",
                                fontWeight: "bold",
                                width: 100,
                            },
                        },
                    },
                    data: namelist
                },
                series: [
                    {
                        name: 'Access From',
                        type: 'pie',
                        radius: ['40%', '70%'],
                        center: ["30%", "50%"],
                        color: ["#4C98FB", "#EEC94C", "#26C7C8"],
                        avoidLabelOverlap: false,
                        label: {
                            show: false,
                            position: 'center',
                            formatter: (data) => {
                                return (
                                    "{a|" +
                                    data.data.value +
                                    "}" +
                                    "\r\n" +
                                    "{b|" +
                                    data.data.title +
                                    "}"
                                );
                            },
                            rich: {
                                a: {
                                    fontSize: 16,
                                    lineHeight: 18,
                                    color: "#fff",
                                    fontWeight: "bold",
                                    align: "center",
                                },
                                b: {
                                    fontSize: 12,
                                    lineHeight: 14,
                                    color: "#fff",
                                    align: "center",
                                },
                            },
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: 40,
                                fontWeight: 'bold'
                            }
                        },
                        labelLine: {
                            show: false
                        },
                        data: namelist
                    }
                ]
            };
            dataSource.setOption(option);
            window.addEventListener("resize", function () {
                dataSource.resize();
            });
        },
        /**
         * @name 获取各学段学科资源
         */
        async getStateresource() {
            this.resourcearr = [];
            const promises = [];
            let length = Object.keys(this.phase).length
            for (let i = 0; i < length; i++) {
                let params = {
                    regionId: this.regionId,
                    provinceId: this.provinceId,
                    cityId: this.cityId,
                    districtId: this.districtId,
                    address: this.address,
                    startTime: this.startTime ? `${this.startTime} 00:00:00` : '',
                    endTime: this.endTime ? `${this.endTime} 23:59:59` : '',
                    phase: Object.values(this.phase)[i]
                };
                promises.push(getPlatformSubjectResourceStatAPI(params));
            }
            const results = await Promise.all(promises);
            results.forEach((res, i) => {
                let sum = 0;
                res.forEach((item) => {
                    sum += Number(item.rsNum)
                })
                this.resourcearr.push({ title: Object.keys(this.phase)[i], value: sum })
            });
            //初始化图表
            this.initEchart();
        }

    },
    mounted() {
        //  获取各学段学科资源
        this.getStateresource();

    }
}


</script>
<style lang="scss" scoped>
.state-resource-chart {
    width: 100%;
    height: 275px;
    background: rgba(9, 19, 66, 0.94);
    border-radius: 0px 0px 4px 4px;
    margin-top: 25px;

    .state-resource-chart-title {
        background: url("~@/assets/images/qingxudataboard/title-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 13px 0 18px;

        .name {
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #FFFFFF;
        }

        .detail {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #B9E3F7;
            cursor: pointer;
        }
    }

    .chart {
        width: 100%;
        height: 240px;
    }
}
</style>